/* Fade Index product page: sizes, pre-order, add to bag, gallery count, zoom. */
(function () {
  var root = document.querySelector('[data-fp]');
  if (!root) return;
  var form = document.getElementById('fp-form');
  var idEl = root.querySelector('[data-fp-id]');
  var btn = root.querySelector('[data-fp-add]');
  var label = root.querySelector('[data-fp-label]');
  var btnPrice = root.querySelector('[data-fp-btn-price]');
  var price = root.querySelector('[data-fp-price]');
  var note = root.querySelector('[data-fp-note]');
  var msg = root.querySelector('[data-fp-msg]');
  var toast = root.querySelector('[data-fp-toast]');
  var preLabel = root.getAttribute('data-pre-label') || 'Pre-order';
  var preNote = root.getAttribute('data-pre-note') || '';
  var preProp = root.getAttribute('data-pre-prop') || '';

  function prop(on) {
    var el = form.querySelector('input[name="properties[Pre-order]"]');
    if (on && !el) {
      el = document.createElement('input');
      el.type = 'hidden'; el.name = 'properties[Pre-order]'; el.value = preProp;
      form.appendChild(el);
    } else if (!on && el) { el.remove(); }
  }

  function select(input, push) {
    if (!input) return;
    var state = input.getAttribute('data-state');
    idEl.value = input.value;
    price.textContent = input.getAttribute('data-price');
    btnPrice.textContent = input.getAttribute('data-price');
    msg.textContent = '';
    if (state === 'out') {
      btn.disabled = true; label.textContent = 'Sold out'; note.hidden = true; prop(false);
    } else if (state === 'pre') {
      btn.disabled = false; label.textContent = preLabel; note.textContent = preNote; note.hidden = !preNote; prop(true);
    } else {
      btn.disabled = false; label.textContent = 'Add to bag'; note.hidden = true; prop(false);
    }
    if (push && window.history.replaceState) {
      var u = new URL(window.location.href); u.searchParams.set('variant', input.value);
      window.history.replaceState({}, '', u.toString());
    }
  }

  var radios = root.querySelectorAll('input[name="fp-size"]');
  for (var i = 0; i < radios.length; i++) {
    radios[i].addEventListener('change', function (e) { select(e.target, true); });
  }
  select(root.querySelector('input[name="fp-size"]:checked'), false);

  var toastTimer;
  function showToast(text) {
    root.querySelector('[data-fp-toast-text]').textContent = text;
    toast.hidden = false;
    requestAnimationFrame(function () { toast.classList.add('is-on'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-on');
      setTimeout(function () { toast.hidden = true; }, 300);
    }, 4000);
  }

  form.addEventListener('submit', function (e) {
    if (!window.fetch || !window.FormData) return;
    e.preventDefault();
    if (btn.disabled) return;
    var was = label.textContent;
    btn.disabled = true; label.textContent = 'Adding';
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add that one.');
        return fetch(base + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('fi:cart', { detail: { count: cart.item_count } }));
        label.textContent = 'Added';
        var size = root.querySelector('input[name="fp-size"]:checked');
        var name = document.querySelector('.fp-title');
        showToast((name ? name.textContent.trim() : 'Tee') + (size ? ', ' + size.parentNode.querySelector('.fp-size-name').textContent : '') + ' added');
        setTimeout(function () { btn.disabled = false; label.textContent = was; }, 1400);
      })
      .catch(function (err) {
        btn.disabled = false; label.textContent = was;
        msg.textContent = err.message;
      });
  });

  var track = root.querySelector('[data-fp-track]');
  var count = root.querySelector('[data-fp-i]');
  if (track && count) {
    track.addEventListener('scroll', function () {
      var w = track.clientWidth || 1;
      count.textContent = Math.round(track.scrollLeft / w) + 1;
    }, { passive: true });
  }

  var dlg = root.querySelector('[data-fp-dialog]');
  var img = root.querySelector('[data-fp-zoom-img]');
  if (dlg && dlg.showModal) {
    root.addEventListener('click', function (e) {
      var s = e.target.closest('[data-fp-zoom]');
      if (s && window.matchMedia('(min-width: 990px)').matches) {
        img.src = s.getAttribute('data-fp-zoom');
        dlg.showModal();
      }
      if (e.target.closest('[data-fp-close]') || e.target === dlg) dlg.close();
    });
  }
})();
